import { createTelemetryObject, createTelemetry } from '@shared/core/analytics';
import { EventVenueState } from './useEventVenueDialog';
import { ScoringPriorityField } from '@graphql/generated';

const page = 'accommodations.venue';
const category = 'website';
const pagePrefix = 'admin';
const action = 'TravelButtonInteracted';

const actionProps = {
  page,
  action,
  category,
  pagePrefix,
};

const telemetryObject = createTelemetryObject({
  pages: {
    eventVenueDialog: (state: EventVenueState) => ({
      category,
      pagePrefix,
      page: 'eventVenueDialog',
      extraPageInfo: {
        state,
      },
    }),
  },
  actions: {
    closeEventVenueDialog: (state: EventVenueState, eventHandle?: string) => ({
      ...actionProps,
      label: 'closeEventVenueDialog',
      extraInfo: {
        state,
        eventHandle,
      },
    }),
    createSaveEventVenue: (location: { name?: string; latitude: number; longitude: number }, eventHandle?: string) => ({
      ...actionProps,
      label: 'createSaveEventVenue',
      extraInfo: {
        location,
        eventHandle,
      },
    }),
    confirmSaveEventVenue: (location: { name?: string; latitude: number; longitude: number }, eventHandle?: string) => ({
      ...actionProps,
      label: 'confirmSaveEventVenue',
      extraInfo: {
        location,
        eventHandle,
      },
    }),
    updateEventVenue: (location: { name?: string; latitude: number; longitude: number }, eventHandle?: string) => ({
      ...actionProps,
      label: 'updateEventVenue',
      extraInfo: {
        location,
        eventHandle,
      },
    }),
    eventVenueDialogStateChanged: (state: EventVenueState, eventHandle?: string) => ({
      ...actionProps,
      label: 'eventVenueDialogStateChanged',
      extraInfo: {
        state,
        eventHandle,
        flow: 'IntroToAccom',
      },
    }),
    revealHotelPicks: (eventHandle?: string) => ({
      ...actionProps,
      label: 'revealHotelPicks',
      extraInfo: {
        eventHandle,
      },
    }),
    scoringPriorityFieldsChanged: (scoringPriorityFieldsTitle: ReadonlyArray<string>, eventHandle?: string) => ({
      ...actionProps,
      label: 'scoringPriorityFieldsChanged',
      extraInfo: { scoringPriorityFieldsTitle, eventHandle, flow: 'IntroToAccom' },
    }),
    revealHotelMatches: (scoringPriorityFields: ReadonlyArray<ScoringPriorityField>, state: EventVenueState, eventHandle?: string) => ({
      ...actionProps,
      label: 'revealHotelMatches',
      extraInfo: { scoringPriorityFields, state, eventHandle, flow: 'IntroToAccom' },
    }),
    hotelsNextCtaClick: (value: 'PreviewPage' | 'BrowseHotels', state: EventVenueState, eventHandle?: string) => ({
      ...actionProps,
      label: 'hotelsNextCtaClick',
      extraInfo: { value, state, eventHandle, flow: 'IntroToAccom' },
    }),
    resetHasSeenAccommodationsTour: () => ({
      ...actionProps,
      label: 'resetHasSeenAccommodationsTour',
    }),
  },
});

export const { useTelemetry: useEventVenueDialogTelemetry } = createTelemetry(telemetryObject);
